<section id="content">
  <!-- Message when user doesn't have access to any charts -->
  <div class="card" *ngIf="
    !hasChartAccess(chartCodes.prospectSummary) &&
    !hasChartAccess(chartCodes.customerProspectSummary) &&
    !hasChartAccess(chartCodes.prospectActivitySummary) &&
    !hasChartAccess(chartCodes.monthlyProspectsOverview) &&
    !hasChartAccess(chartCodes.BrandProspectSummary)
  ">
    <div class="card-body text-center p-5">
      <h3>No Dashboard Access</h3>
      <p>You don't have access to any dashboard charts. Please contact your administrator for assistance.</p>
    </div>
  </div>
 
  <app-prospect-summary-customers
    *ngIf="hasChartAccess(chartCodes.prospectSummary)"
    [userId]="userId">
  </app-prospect-summary-customers>

  <app-prospect-summary-sectors
  *ngIf="hasChartAccess(chartCodes.prospectSummary)"
  [userId]="userId">
</app-prospect-summary-sectors>

 
  <app-prospect-activity-summary
    *ngIf="hasChartAccess(chartCodes.prospectActivitySummary)">
  </app-prospect-activity-summary>

  <app-app-prospect-summary
    *ngIf="hasChartAccess(chartCodes.monthlyProspectsOverview)">
  </app-app-prospect-summary>

  <app-customer-prospect-summary
    *ngIf="hasChartAccess(chartCodes.customerProspectSummary)">
  </app-customer-prospect-summary>

  <app-brand-prospect-summary
    *ngIf="hasChartAccess(chartCodes.BrandProspectSummary)">
  </app-brand-prospect-summary>
</section>